module.exports = __webpack_public_path__ + "img/copy-icon.0c6fe386.svg";